import { render, staticRenderFns } from "./CollectionUpdateDialog.vue?vue&type=template&id=bfee3de4&scoped=true&lang=true"
import script from "./CollectionUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CollectionUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./CollectionUpdateDialog.vue?vue&type=style&index=0&id=bfee3de4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee3de4",
  null
  
)

export default component.exports